// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductBuyerHeader":"cx_a bhc_sp","ProductBuyerHeader__username":"cx_b bhc_vf"};